export default [
	'bedc:builder:lookup',

	'bedc:builder:list',

	'bedc:builder:search',

	'bedc:builder:create:{organizationId}',
	'bedc:builder:create-simple:{organizationId}',
] as const;
